import { numberInputAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(numberInputAnatomy.keys);

const outline = definePartsStyle({
  field: {
    background: 'white',
    fontSize: '14px'
  },
  stepper: {
    fontSize: '8px'
  }
});

const sm = definePartsStyle({
  field: {
    borderRadius: 4,
  }
});

const md = definePartsStyle({
  field: {
    borderRadius: 8,
  }
});

export const NumberInput = defineMultiStyleConfig({
  sizes: {
    sm,
    md
  },
  variants: { outline }
});